/* eslint-disable @typescript-eslint/no-unsafe-return */
import {connect} from "react-redux"
import {createSelector} from "reselect"
import uniq from "lodash/uniq"
import State from "../../models/State"
import {setFilterAndSortClearAllAction, setFilterClearAllAction} from "../../ducks/search"
import {setTabbedFiltersOpenAction, syncTabbedFiltersFromSearch} from "../../ducks/tabbedFilters"
import {getIsAnyFilterSelected} from "../../utils/isAnyFilterSelected"
import TrackFilterClearAll from "../../events/trackEvent/events/trackFilterClearAll"
import {FacetState} from "../../models/FacetsState"
import {CATEGORY, FEAT, SCORE, SORT} from "../../config/constants"
import {Filters} from "../../models/Filter"

export interface OwnProps {
    enableSortBy?: boolean
}

const selectFilters = (state: State) => state.tabbedFilters.filters
const selectFacets = (state: State) => state.tabbedFilters.facets
const selectHistoricFacetFilter = (state: State) => state.tabbedFilters.historicFacetFilter
const selectEnableStructuredBrowsing = (state: State) => state.search.enableStructuredBrowsing

export const selectRefinedFilters = createSelector(
    [selectFacets, selectFilters, selectHistoricFacetFilter, selectEnableStructuredBrowsing],
    (facets, filters, historicFacetFilter, enableStructuredBrowsing) => {
        const priceFilter = Object.values(filters).find(item => item?.type === "price")
        const isAnyFilterSelected = getIsAnyFilterSelected(historicFacetFilter, priceFilter)

        let refinedFilters: Filters = filters

        // TODO: next two statements are ignored (POC only)
        /* istanbul ignore next */
        const categoryFacets: FacetState[] = Object.keys(facets)
            .filter(facetName => facetName.startsWith(`${CATEGORY}:`))
            .map(facetName => facets[facetName])

        /* istanbul ignore next */
        if (categoryFacets.length > 0 && categoryFacets[0].u !== undefined && enableStructuredBrowsing) {
            const {category, ...rest} = filters
            refinedFilters = rest
        }

        return {
            refinedFilters,
            isAnyFilterSelected,
        }
    },
)

const selectFiltersSort = (state: State) => state.tabbedFilters.filtersSort

const makeNewFilterSort = createSelector([selectFiltersSort], filtersSort => {
    const filtersSortLength = filtersSort.filter(f => f === FEAT).length
    const newFilterSort = uniq([
        ...filtersSort.slice(0, filtersSortLength),
        SORT,
        ...filtersSort.slice(filtersSortLength),
    ])

    return {
        newFilterSort,
    }
})

const mapStateToProps = (state: State, ownProps: OwnProps) => {
    const {enableSortBy} = ownProps
    const {isOpen, selectedFilter} = state.tabbedFilters
    const {disableIcons, singleOptionFacetList, sorting} = state.search
    const {text, template} = state

    const {refinedFilters, isAnyFilterSelected} = selectRefinedFilters(state)

    let sortFilterSelected = false
    if (enableSortBy && sorting.selected !== SCORE) {
        sortFilterSelected = true
    }

    return {
        filters: refinedFilters,
        isAnyFilterSelected: isAnyFilterSelected || sortFilterSelected,
        isOpen,
        hasSelectedFacet: Boolean(selectedFilter),
        text,
        singleOptionFacetList,
        disableIcon: disableIcons.mobileFilter,
        templating: template,
        ...makeNewFilterSort(state),
    }
}

export const mapDispatchToProps = (dispatch: any) => {
    return {
        clearAll: (enableSortBy: boolean) => {
            TrackFilterClearAll()
            dispatch(enableSortBy ? setFilterAndSortClearAllAction() : setFilterClearAllAction())
        },
        syncTabbedFilters: (isOpen: boolean) => dispatch(syncTabbedFiltersFromSearch(isOpen)),
        closeTabbedFilters: (isOpen: boolean) => dispatch(setTabbedFiltersOpenAction(isOpen)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
